import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/*
 * Default buffer size
 */
var DEFAULT_BUFFER_SIZE = 1000;
/*
 * Default flush timeout
 */

var DEFAULT_FLUSH_TIMEOUT = 1000;
/*
 * Default retry count
 */

var DEFAULT_RETRY_COUNT = 3;
/*
 * Default retry backoff
 */

var DEFAULT_RETRY_BACKOFF = 100;
/*
 * Default function for computing log size (serialized JSON length + 1 for comma)
 */

export var calculateJsonLogSizeBytes = function calculateJsonLogSizeBytes(log) {
  return JSON.stringify(log).length + 1;
};
/**
 * batch the buffer coming in, process them and then resolve
 *
 * @param size - Number
 * @param flushTimeout - Number
 * @param retryCount - Number
 * @param retryBackoff - Number
 * @param sizeBytes - Size of the batch (in bytes) that triggers flushing. Set to 0 to disable.
 * @param calculateLogSizeBytes - Function to calculate size of a single ILogtailLog instance (in bytes).
 */

export default function makeBatch() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_BUFFER_SIZE;
  var flushTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FLUSH_TIMEOUT;
  var retryCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_RETRY_COUNT;
  var retryBackoff = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_RETRY_BACKOFF;
  var sizeBytes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var calculateLogSizeBytes = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : calculateJsonLogSizeBytes;
  var timeout;
  var cb;
  var buffer = [];
  var bufferSizeBytes = 0;
  var retry = 0; // Wait until the minimum retry backoff time has passed before retrying

  var minRetryBackoff = 0;
  /*
   * Process then flush the list
   */

  function flush() {
    return _flush.apply(this, arguments);
  }
  /*
   * Start timeout to flush
   */


  function _flush() {
    _flush = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var currentBuffer, currentBufferSizeKB;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (timeout) {
                clearTimeout(timeout);
              }

              timeout = null;
              currentBuffer = buffer;
              currentBufferSizeKB = bufferSizeBytes;
              buffer = [];
              bufferSizeBytes = 0;
              _context3.prev = 6;
              _context3.next = 9;
              return cb(currentBuffer.map(function (d) {
                return d.log;
              }));

            case 9:
              currentBuffer.forEach(function (d) {
                return d.resolve(d.log);
              });
              retry = 0;
              _context3.next = 25;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](6);

              if (!(retry < retryCount)) {
                _context3.next = 23;
                break;
              }

              retry++;
              minRetryBackoff = Date.now() + retryBackoff;
              buffer = buffer.concat(currentBuffer);
              bufferSizeBytes += currentBufferSizeKB;
              _context3.next = 22;
              return setupTimeout();

            case 22:
              return _context3.abrupt("return");

            case 23:
              currentBuffer.map(function (d) {
                return d.reject(_context3.t0);
              });
              retry = 0;

            case 25:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[6, 13]]);
    }));
    return _flush.apply(this, arguments);
  }

  function setupTimeout() {
    return _setupTimeout.apply(this, arguments);
  }
  /*
   * Batcher which takes a process function
   * @param fn - Any function to process list
   */


  function _setupTimeout() {
    _setupTimeout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!timeout) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt("return");

            case 2:
              return _context5.abrupt("return", new Promise(function (resolve) {
                timeout = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return flush();

                        case 2:
                          resolve();

                        case 3:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                })), flushTimeout);
              }));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _setupTimeout.apply(this, arguments);
  }

  return {
    initPusher: function initPusher(fn) {
      cb = fn;
      /*
       * Pushes each log into list
       * @param log: ILogtailLog - Any object to push into list
       */

      return /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(log) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", new Promise( /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
                      var isBufferFullEnough;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              buffer.push({
                                log: log,
                                resolve: resolve,
                                reject: reject
                              }); // We can skip log size calculation if there is no max size set

                              // We can skip log size calculation if there is no max size set
                              if (sizeBytes > 0) {
                                bufferSizeBytes += calculateLogSizeBytes(log);
                              } // If the buffer is full enough, flush it
                              // Unless we're still waiting for the minimum retry backoff time


                              // If the buffer is full enough, flush it
                              // Unless we're still waiting for the minimum retry backoff time
                              isBufferFullEnough = buffer.length >= size || sizeBytes > 0 && bufferSizeBytes >= sizeBytes;

                              if (!(isBufferFullEnough && Date.now() > minRetryBackoff)) {
                                _context.next = 8;
                                break;
                              }

                              _context.next = 6;
                              return flush();

                            case 6:
                              _context.next = 10;
                              break;

                            case 8:
                              _context.next = 10;
                              return setupTimeout();

                            case 10:
                              return _context.abrupt("return", resolve);

                            case 11:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x2, _x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }()));

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
    },
    flush: flush
  };
}